"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMarkdown = void 0;
const md_utils_1 = require("../../../export/md.utils");
const toMarkdown = (element, context) => {
    var _a;
    const file = (_a = element.value) === null || _a === void 0 ? void 0 : _a.file;
    if (!file) {
        return '';
    }
    const url = (0, md_utils_1.getFileUrl)(file, context);
    if (!url) {
        return '';
    }
    const label = 'Video';
    return `[${label}](${url})`;
};
exports.toMarkdown = toMarkdown;
